import React from 'react';

import { Header, RegistrationHistory as RegistrationHistoryComponent } from 'components';
import { PrivateRoute } from 'utils';

export const RegistrationHistoryPage = () => {
  PrivateRoute();

  return (
    <>
      <Header />
      <RegistrationHistoryComponent />
    </>
  );
};
